import { IconBadge } from "@/DesignSystem";

import styles from "./GridCell.module.scss";

type AlertVariant = "warning" | "alarming";

interface GridCellProps {
    id: string;
    value: string;
    showAlert?: boolean;
    alertVariant?: AlertVariant;
    alertTooltipText?: string;
    dataCy?: string;
}

const variantMapper: Record<AlertVariant, string> = {
    warning: "",
    alarming: styles.error
};

const getIconBadgeDataCy = (variant?: AlertVariant): string | undefined => {
    if (variant === "warning")
        return "care-element-grid-warning-icon";
    if (variant === "alarming")
        return "care-element-grid-alarming-icon";
    return undefined;
};

function GridCell({ id, value, showAlert, alertVariant, alertTooltipText: tooltipText, dataCy }: Readonly<GridCellProps>): JSX.Element {
    return (
        <div className={styles.cellContainer} title={showAlert ? tooltipText : null} data-cy={dataCy}>
            <p className={`${showAlert ? styles.highlight : ""} ${showAlert ? variantMapper[alertVariant] : ""}`}>
                {value}
            </p>
            <div id={id}>
                {showAlert && (<IconBadge dataCy={getIconBadgeDataCy(alertVariant)} size="xs" variant={alertVariant} />)}
            </div>
        </div>
    );
}

export { GridCell };
